// extracted by mini-css-extract-plugin
module.exports = {"outreachCardHeader":"_3wv80pkV","outreachCardName":"_1H6aWudO","outreachCardList":"_3TSciWv7"};